type AppleMailInstructionsProps = {
  fileName: string;
};

/**
 * AppleMailInstructions.tsx
 * How to install the generated .eml signature in Apple Mail, shown right
 * after the file is downloaded. Mail cannot import HTML: the signature has to
 * be copied out of a rendered message and pasted into the signature editor.
 */
export const AppleMailInstructions = ({
  fileName,
}: AppleMailInstructionsProps): JSX.Element => (
  <div className="mt-12 bg-white rounded-lg p-6 border-2 border-ligthGray">
    <h2 className="text-xl font-semibold mb-2">
      Come installare la firma su Mac (Apple Mail)
    </h2>
    <p className="text-darkGray mb-6">
      Non serve toccare nessun file di sistema.
    </p>

    <ol className="flex flex-col gap-4 list-decimal pl-5">
      <li>
        <strong>Apri il file .eml</strong>
        <br />
        Fai doppio click su <code>{fileName}</code>: si apre una finestra di
        messaggio in Mail.
        <br />
        <span className="text-darkGray">
          Se i loghi non si vedono, clicca prima su &ldquo;Carica contenuto
          remoto&rdquo; nella barra in alto del messaggio, altrimenti verranno
          copiati senza immagini.
        </span>
      </li>
      <li>
        <strong>Seleziona e copia la firma</strong>
        <br />
        Clicca nel corpo del messaggio (dove vedi logo, nome, telefono, ecc.),
        premi <code>⌘A</code> per selezionare tutto il contenuto visibile e{" "}
        <code>⌘C</code> per copiarlo.
      </li>
      <li>
        <strong>Crea una nuova firma in Mail</strong>
        <br />
        Vai su <em>Mail → Impostazioni → Firme</em>, seleziona l&apos;account
        che usi per lavorare e clicca <code>+</code> per creare una nuova
        firma. Nella casella di destra cancella il testo già presente e premi{" "}
        <code>⌘V</code> per incollare la firma copiata.
        <br />
        <span className="text-darkGray">
          Nella stessa schermata deseleziona &ldquo;Fai sempre corrispondere al
          font predefinito dei messaggi&rdquo;, altrimenti Mail riscrive i font
          della firma.
        </span>
      </li>
      <li>
        <strong>Verifica che sia corretta</strong>
        <br />
        Devono comparire logo, nome, ruolo, telefono, indirizzo e disclaimer,
        esattamente come nel messaggio. Se vedi solo codice HTML o testo
        grezzo, ripeti il punto 2 assicurandoti di aver selezionato tutto il
        contenuto <em>visibile</em> del messaggio.
      </li>
      <li>
        <strong>Chiudi le impostazioni</strong>
        <br />
        Quando crei un nuovo messaggio puoi selezionare la nuova firma dal menu
        a tendina delle firme.
      </li>
    </ol>
  </div>
);
